import { httpInterceptor } from './http.interceptor';
import { tokenInterceptor } from './token.interceptor';
import { languageInterceptor } from './language.interceptor';
import { loadingInterceptor } from './loading.interceptor';
import { errorHandlerInterceptor } from './error-handler.interceptor';
import { responseNormalizerInterceptor } from './response-normalizer.interceptor';

export const interceptorProviders = [
  httpInterceptor,
  tokenInterceptor,
  languageInterceptor,
  loadingInterceptor,
  responseNormalizerInterceptor,
  errorHandlerInterceptor,
];
